import {
  Card,
  CardBody,
  CardHeader,
  Flex,
  Heading,
  Center,
  FormControl,
  FormLabel,
  Input,
  FormErrorMessage,
  Button,
  HStack,
  Spacer,
  useDisclosure,
  Spinner,
  useToast,
} from "@chakra-ui/react";
import React, { useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import { NAV_ITEMS } from "../layouts/Menu/constant";
import { chuyenLichSuApi } from "../apis/khung.gia.dat.api";
import { getToast } from "../utils";

export default function NhapLichSuGiaDat() {
  const toast = useToast();
  const { pathname } = useLocation();
  const { isOpen, onClose, onOpen } = useDisclosure();

  const title = useMemo(() => {
    if (!pathname) return "";
    return NAV_ITEMS[2].children?.find((p) => p.href === pathname)?.label || "";
  }, [pathname]);

  const [input, setInput] = useState(`${new Date().getFullYear()}`);
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInput(e.target.value);
  };
  const isError = input === "";

  const getType = useMemo(() => {
    if (title === "/chuyen-bang-gia-dat-vao-lich-su") return "BGD";
    if (title === "/chuyen-he-so-dieu-chinh-vao-lich-su") return "HSDC";
    return "KGD";
  }, [title]);

  const handleSubmit = async () => {
    onOpen();
    try {
      const year = parseInt(input);
      const rs = await chuyenLichSuApi(year, getType);
      toast(getToast(`${title} năm ${input} thành công.`, 'success', 'Thành công.'))
    } catch (ex) {
      toast(getToast(`Đã có lỗi khi ${title}. Vui lòng thử lại sau.`))
    }
    onClose();
  };

  return (
    <Flex
      w="full"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
    >
      <Card w="40%" mt="30px">
        <CardHeader>
          <Center>
            <Heading as="h5" size="md" textTransform='uppercase'>
              {title}
            </Heading>
          </Center>
        </CardHeader>
        <CardBody>
          <FormControl>
            <FormLabel>Nhập năm cần {title} :</FormLabel>
            <HStack>
              <Input
                type="number"
                minLength={4}
                maxLength={4}
                value={input}
                onChange={handleInputChange}
                w="60%"
              />
              {!isError && (
                <FormErrorMessage>
                  Vui lòng nhập vào số năm muốn chuyển.
                </FormErrorMessage>
              )}
              <Spacer />
              <Button colorScheme="teal" w="250px" onClick={handleSubmit}
              isDisabled={isOpen}
              >
                {isOpen && <Spinner />}
                {!isOpen && <span>Chuyển lịch sử</span>}
              </Button>
            </HStack>
          </FormControl>
        </CardBody>
      </Card>
    </Flex>
  );
}
